import React from 'react';
import { Field, useFormikContext } from 'formik';
import { CustomSelectComponent } from 'motion-components';
import { useTranslation } from 'react-i18next';

/* ----------- Select Year ------------------ */
export const SelectYear = ({
  required = false,
  name = 'year',
  title = 'Year',
  startYear = 2020,
  endYear = new Date().getFullYear(),
  ...rest
}) => {
  const { t } = useTranslation();
  const yearOptions = () => {
    const firstYear = startYear;
    const currentYear = endYear;
    const options = [];

    for (let year = currentYear; year >= firstYear; year--) {
      options.push({ value: year, label: year.toString() });
    }
    return options;
  };

  return (
    <Field
      {...rest}
      required={required}
      name={name}
      title={t(title)}
      component={CustomSelectComponent}
      options={yearOptions()}
    />
  );
};

